import { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import '../App.css';
import RecentPost from "../RecentPost";
import ContactNumber from "../ContactNumber";
import { Helmet } from "react-helmet";

export default function MonthlyBasisPginKharadi(){
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    
    const faqs = [
        {
            question: "What types of rooms are available in monthly basis PGs in Kharadi?",
            answer: "Monthly basis PGs typically offer single, double, and triple sharing rooms, all furnished with basic amenities like beds, wardrobes, and study tables. Some premium PGs also provide air-conditioned rooms."
        },
        {
            question: "Is food included in the rent?",
            answer: "Yes, most PGs include home-cooked meals (breakfast, lunch, and dinner) in the monthly rent. The meals are usually vegetarian and nutritious."
        },
        {
            question: "Is Wi-Fi available at the PG?",
            answer: "Yes, most PGs provide free Wi-Fi to residents. This is especially useful for students and professionals who require the internet for their work or studies."
        },
        {
            question: "Are the rooms clean and well-maintained?",
            answer: "Yes, the PGs generally offer regular housekeeping services to keep rooms, common areas, and bathrooms clean and hygienic."
        },
        {
            question: "Can I stay for just one month?",
            answer: "Yes, you can stay in a PG on a monthly basis. It’s a flexible option, ideal for those who need short-term accommodation or are unsure of their long-term plans."
        },
        {
            question: "What is the security like at PGs in Kharadi?",
            answer: "24/7 security is usually provided, including CCTV surveillance and security guards to ensure the safety of residents. Many PGs also have controlled access points."
        },
        {
            question: "Are laundry services provided?",
            answer: "Yes, laundry services are available in most PGs, where your clothes will be washed, ironed, and delivered back to you for an additional fee."
        },
        {
            question: "Are guests allowed to visit?",
            answer: "Guest policies vary from PG to PG. Some may allow guests during specific hours, while others may have a strict visitor policy to maintain privacy and security. Always check the rules beforehand."
        },
        {
            question: "Is there a curfew for PG residents?",
            answer: "Some PGs may have a curfew or entry restrictions, especially for women. The curfew time typically ensures safety and security, and it is best to inquire about this at the time of booking."
        },
        {
            question: "What facilities are available in the common areas?",
            answer: "Common areas in most PGs include lounges, TV rooms, and dining spaces where residents can relax, socialize, and unwind. Some PGs may also offer additional recreational facilities."
        }
    ];
    
    const testimonials = [
        {
            quote: "I’ve been staying at OM Sai PG in Kharadi on a monthly basis, and I couldn’t be happier with my experience. The rooms are spacious, clean, and equipped with all the necessary amenities like high-speed Wi-Fi, a comfortable bed, and a study desk. The food is fresh and tasty, and the staff is very friendly and responsive to all requests. The location is perfect, with easy access to public transport and nearby shops. If you’re looking for a hassle-free, affordable PG in Kharadi, I highly recommend OM Sai.",
            author: "- Sandeep Patel, Software Developer"
        },
        {
            quote: "OM Sai PG in Kharadi has been the perfect place for me to stay on a monthly basis. The environment is peaceful and safe, and the management takes great care to ensure everything is well-maintained. The rooms are spacious and well-furnished, making it a comfortable space to live in. The food is homely and nutritious, and the location is ideal for both work and leisure. The staff is always ready to help with anything. I highly recommend OM Sai PG for anyone looking for a reliable and affordable PG in Kharadi.",
            author: "- Neelam Reddy, Marketing Executive"
        }
    ];
    
      
      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
      };
    
    
    
    
    return(
        <>
<Helmet>
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Om Sai PG",
      "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
      "url": "https://www.omsaipg.in/Monthly-Basis-PG-in-Kharadi",
      "logo": "https://www.omsaipg.in/images/logo.jpg",
      "image": "https://www.omsaipg.in/images/img/keyword-image/Monthly-basis-pg-in-kharadi.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91 9763888448",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91 9922248255",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.7",
        "ratingCount": "250",
      },
      "email": "omsaipg@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
        "addressLocality": "Kharadi",
        "addressRegion": "Maharashtra",
        "postalCode": "411014",
        "addressCountry": "IN",
      },
      "sameAs": [
        "https://www.facebook.com/omsaipg",
        "https://www.instagram.com/omsaipg",
        "https://www.linkedin.com/company/omsaipg"
      ],
      "priceRange": "INR 8,500-6000",
      "paymentAccepted": "Cash, UPI, Credit Card",
      "telephone": "+91 9763888448",
      "email": "omsaipgpune@gmail.com",
      "keywords": [
        "Monthly Basis PG in Kharadi",
        "PG with food in Kharadi",
        "PG in Wagholi",
        "Hostels in Pune",
        "Paying Guest in Chandan Nagar"
      ],
      "openingHours": "Mo-Su 09:00-22:00"
    })}
  </script>

  {/* Title */}
  <title>Om Sai PG | Monthly Basis PG in Kharadi | PG with Food | Hostels in Pune</title>

  {/* Meta Tags */}
  <meta
    name="description"
    content="Om Sai PG offers affordable monthly basis PG accommodations in Kharadi, Pune with food included. Ideal for students and professionals near Eon IT Park."
  />
  <meta
    name="keywords"
    content="Monthly Basis PG in Kharadi, PG with food in Kharadi, PG in Wagholi, Hostels in Pune, Paying Guest in Chandan Nagar"
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
  />
  <meta
    property="og:description"
    content="Om Sai PG offers the best monthly basis PG accommodations in Kharadi, Pune, with food included. Perfect for students and professionals near Eon IT Park."
  />
  <meta property="og:image" content="https://www.omsaipg.in/img/keyword-image/Monthly-basis-pg-in-kharadi.jpg" />
  <meta property="og:url" content="https://www.omsaipg.in/Monthly-Basis-PG-in-Kharadi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Om Sai PG" />
</Helmet>



     <section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img1">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>Monthly Basis PG in Kharadi </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>Monthly Basis PG in Kharadi </h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <Link to="/">Home</Link>
                                            </li>
                                            <li>Monthly Basis PG in Kharadi </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

      {/* <!-- Page Banner End --> */}

      <div class="section-about padding-tb-50 keywordsection">
        <div className="container">
          <div className="row d-flex justify-content-around">
            <div className="col-12 col-md-8">
              <div className="keyword-img">
                <img src="img/keyword-image/Monthly-basis-pg-in-kharadi.jpg" className="img-fluid" alt="Monthly-basis-pg-in-kharadi" />
              </div>
              <h1>Om Sai PG: Monthly Basis Paying Guest Accommodation in Kharadi, Pune</h1>
<p>Om Sai PG offers a hassle-free, affordable, and comfortable living experience for students and working professionals in one of Pune’s most vibrant and well-connected areas. Our PG offers flexible monthly rent options with all the essential amenities to ensure a convenient and peaceful stay.</p>

<h2>Why Choose Om Sai PG for Monthly Stay in Kharadi?</h2>
<p>Om Sai PG is the perfect choice for anyone looking for reliable and comfortable accommodation in Kharadi. Whether you’re a student, working professional, or someone new to Pune, we provide a home-like environment with all the necessary amenities to meet your needs. Here’s why our PG stands out:</p>
<ol>
  <li><strong>Prime Location in Kharadi:</strong>
    <ul>
      <li>Located near EON IT Park, World Trade Center, and other major commercial hubs, Om Sai PG is strategically positioned to provide easy access to offices, schools, colleges, and shopping areas.</li>
      <li>The area is well-connected by public transport, making it easy for you to commute around Pune.</li>
    </ul>
  </li>
  <li><strong>Affordable and Flexible Monthly Rent:</strong>
    <ul>
      <li>We understand that everyone has different needs and budgets. At Om Sai PG, we offer flexible monthly rental plans, ensuring that your stay is cost-effective without compromising on comfort.</li>
    </ul>
  </li>
  <li><strong>Safety and Security:</strong>
    <ul>
      <li>We prioritize the safety of our residents with 24/7 security personnel, CCTV surveillance, and biometric access to ensure a safe living environment.</li>
      <li>Feel at ease knowing that your safety and well-being are our top priorities.</li>
    </ul>
  </li>
  <li><strong>Comfortable Living Space:</strong>
    <ul>
      <li>Our rooms are well-furnished with comfortable beds, wardrobes, and study tables, making it a perfect living space for students and professionals alike.</li>
    </ul>
  </li>
</ol>

<h2>Facilities at Om Sai PG in Kharadi</h2>
<p>When you choose Om Sai PG, you get access to a variety of facilities that ensure your stay is as comfortable and convenient as possible. Here’s what’s included:</p>
<ol>
  <li><strong>Fully Furnished Rooms:</strong>
    <ul>
      <li>Rooms are furnished with comfortable beds, study tables, chairs, and wardrobes, ensuring a relaxing and productive living environment.</li>
    </ul>
  </li>
  <li><strong>Washing Machine:</strong>
    <ul>
      <li>We provide a washing machine for laundry, making it easier for you to do your clothes without hassle.</li>
    </ul>
  </li>
  <li><strong>High-Speed Wi-Fi:</strong>
    <ul>
      <li>Stay connected to work, studies, and entertainment with our fast and reliable internet connection.</li>
    </ul>
  </li>
  <li><strong>24/7 Water Supply:</strong>
    <ul>
      <li>Enjoy a continuous water supply to meet your daily needs.</li>
    </ul>
  </li>
  <li><strong>Geyser for Hot Water:</strong>
    <ul>
      <li>Hot water is available at any time, providing you with the comfort you need after a busy day.</li>
    </ul>
  </li>
  <li><strong>2-Wheeler Parking Available:</strong>
    <ul>
      <li>For those with two-wheelers, secure parking is available at no extra cost.</li>
    </ul>
  </li>
  <li><strong>Fridge in Every Room:</strong>
    <ul>
      <li>Each room comes with a fridge, allowing you to store food and beverages conveniently.</li>
    </ul>
  </li>
  <li><strong>Gas Connection for Cooking:</strong>
    <ul>
      <li>You can cook your own meals with the gas connection provided in the PG.</li>
    </ul>
  </li>
  <li><strong>Free Housekeeping Services:</strong>
    <ul>
      <li>Our housekeeping services ensure that your room and common areas stay clean and well-maintained.</li>
    </ul>
  </li>
  <li><strong>Free Electricity Bills:</strong>
    <ul>
      <li>Your rent includes electricity charges, so there are no hidden costs when it comes to your monthly bills.</li>
    </ul>
  </li>
  <li><strong>Purified Drinking Water:</strong>
    <ul>
      <li>Stay healthy with purified drinking water available throughout the premises.</li>
    </ul>
  </li>
  <li><strong>CCTV Security:</strong>
    <ul>
      <li>We ensure 24/7 security with CCTV cameras covering all areas of the hostel.</li>
    </ul>
  </li>
  <li><strong>Meals Included:</strong>
    <ul>
      <li>Nutritious meals (breakfast and dinner) are included in your monthly rent, ensuring you have home-cooked food every day.</li>
    </ul>
  </li>
</ol>


<h1>Room Types and Rent for Monthly Basis PG in Kharadi</h1>
<p>Om Sai PG offers various room types with flexible monthly rent options, making it a perfect choice for anyone looking for accommodation in Kharadi. All rooms come with meals (breakfast and dinner) included.</p>

<h2>1. Sharing Room (₹8.5k)</h2>
<ul>
  <li><strong>Rent:</strong> ₹8,500 per month</li>
  <li><strong>Meals:</strong> Breakfast and Dinner included</li>
  <li>Spacious shared accommodation with all essential amenities.</li>
</ul>

<h2>2. Sharing Room (₹7k)</h2>
<ul>
  <li><strong>Rent:</strong> ₹7,000 per month</li>
  <li><strong>Meals:</strong> Breakfast and Dinner included</li>
  <li>A budget-friendly option with excellent facilities.</li>
</ul>

<h2>3. Sharing Room (₹6k)</h2>
<ul>
  <li><strong>Rent:</strong> ₹6,000 per month</li>
  <li><strong>Meals:</strong> Breakfast and Dinner included</li>
  <li>Affordable shared living with all the necessary amenities.</li>
</ul>

<h2>Why Choose Kharadi for Your Stay?</h2>
<p>Kharadi is one of Pune’s most popular and well-connected localities, offering several advantages for both students and working professionals:</p>
<ul>
  <li><strong>Proximity to IT Hubs:</strong> Kharadi is home to prominent IT parks like EON IT Park and World Trade Center, making it the ideal location for IT professionals.</li>
  <li><strong>Educational Institutions:</strong> The area is close to several renowned educational institutions, making it a convenient choice for students.</li>
  <li><strong>Easy Connectivity:</strong> Kharadi has excellent connectivity to other parts of Pune through major roads and public transport options.</li>
  <li><strong>Shopping & Entertainment:</strong> With several shopping malls, restaurants, and entertainment venues nearby, you’ll have everything you need within reach.</li>
</ul>

<h2>Book Your Stay at Om Sai PG in Kharadi</h2>
<p>Ready to secure your spot at Om Sai PG for a monthly stay in Kharadi? Our hassle-free booking process makes it easy for you to book your accommodation. Contact us today for more information or to reserve your room:</p>
<ul>
  <li><strong>Phone Number 1:</strong> 9763888448</li>
  <li><strong>Phone Number 2:</strong> 9922248255</li>
</ul>

<h1>Daily Basis PG in Baner, Pune</h1>
<p>If you're looking for a daily basis PG in Baner, Pune, you'll find several accommodations that cater to short-term stays, providing flexibility for people who need a place to stay on a daily rental basis. These PGs offer the convenience of a flexible stay with all essential amenities like meals, Wi-Fi, and housekeeping.</p>

<h2>Features of Daily Basis PG in Baner:</h2>
<ul>
  <li><strong>Flexible Stay:</strong> Pay on a daily basis without committing to long-term stays.</li>
  <li><strong>Essential Amenities:</strong> Furnished rooms with beds, wardrobes, and study tables. Basic facilities like Wi-Fi, laundry, and meals are typically included.</li>
  <li><strong>Location Advantage:</strong> Baner is a prime locality in Pune, known for its proximity to business hubs, IT parks, and educational institutions.</li>
  <li><strong>Security:</strong> 24/7 security, CCTV surveillance, and restricted access for a safe living experience.</li>
  <li><strong>Affordable for Short Stays:</strong> Ideal for individuals visiting for short business trips, conferences, or temporary work in Pune.</li>
</ul>

<h1>Weekly Basis PG in Baner, Pune</h1>
<p>For those who need accommodation for weekly stays, PGs in Baner offer a great solution. Whether you're on a short-term assignment, internship, or project, weekly basis PGs allow you to stay for a week or more with all your basic needs covered.</p>

<h2>Features of Weekly Basis PG in Baner:</h2>
<ul>
  <li><strong>Weekly Rentals:</strong> Rent is charged on a weekly basis, providing cost-effective and flexible living options.</li>
  <li><strong>Fully Equipped Rooms:</strong> Rooms with essential furniture and facilities like Wi-Fi, water, and electricity are included.</li>
  <li><strong>Meals and Housekeeping:</strong> Many PGs offer home-cooked meals and housekeeping services, so you don’t have to worry about cooking or cleaning.</li>
  <li><strong>Comfortable Living:</strong> Ideal for professionals, students, or travelers who need a short-term, hassle-free accommodation.</li>
  <li><strong>Proximity to IT Parks:</strong> Baner is located near several important IT parks like Rajiv Gandhi Infotech Park, making it an ideal choice for tech professionals.</li>
</ul>

<h1>Monthly Basis PG in Baner, Pune</h1>
<p>For those who require more than a few days but less than a long-term stay, monthly basis PG in Baner offers a perfect balance. This type of PG accommodation is ideal for students, working professionals, or anyone in need of a reliable place to stay for a month or more without signing a long-term lease.</p>

<h2>Features of Monthly Basis PG in Baner:</h2>
<ul>
  <li><strong>Affordable Long-Term Stay:</strong> Monthly rents are usually more economical than daily or weekly rentals, offering better rates for longer stays.</li>
  <li><strong>All-Inclusive Rent:</strong> Rent typically covers all utilities such as Wi-Fi, water, electricity, and meals (breakfast, lunch, and dinner).</li>
  <li><strong>Furnished Rooms:</strong> Rooms are usually well-furnished with beds, chairs, tables, and wardrobes for convenience.</li>
  <li><strong>Great Connectivity:</strong> Baner is well-connected to other parts of Pune, making commuting easy for professionals working in nearby IT parks or educational institutions.</li>
  <li><strong>Safety and Security:</strong> Most PGs in Baner provide 24/7 security, CCTV cameras, and monitored access to ensure the safety of residents.</li>
</ul>

<h1>Daily Basis PG in Pune</h1>
<p>PGs on a daily basis in Pune are a convenient solution for those who need temporary accommodation for work, study, or travel. This option is typically used by travelers or people who are in town for a short duration. The PGs in Pune cater to a wide range of needs, from professional stays to student accommodations.</p>

<h2>Features of Daily Basis PG in Pune:</h2>
<ul>
  <li><strong>Flexible Booking:</strong> Rent is charged on a daily basis, ideal for short-term stays.</li>
  <li><strong>Affordable for Short Stays:</strong> Daily rental rates are more economical for people who only need accommodation for a few days or weeks.</li>
  <li><strong>Comprehensive Amenities:</strong> Daily PGs often provide meals, housekeeping, and internet facilities, making it convenient for individuals on the move.</li>
  <li><strong>Variety of Locations:</strong> Daily basis PGs are available in different parts of Pune like Viman Nagar, Kalyani Nagar, Wakad, and Baner.</li>
  <li><strong>Safety & Security:</strong> Most PGs have security personnel and CCTV cameras, ensuring a safe environment for all residents.</li>
</ul>

<h1>PG on Daily Basis in Pune</h1>
<p>If you're searching for a PG on a daily basis in Pune, you'll find numerous options in popular areas like Baner, Viman Nagar, Wakad, and Hinjewadi, which are close to major office complexes, educational institutions, and transport hubs.</p>

<h2>Features of PG on Daily Basis in Pune:</h2>
<ul>
  <li><strong>Convenience for Travelers:</strong> Ideal for business trips, vacations, or those in Pune for a few days or weeks.</li>
  <li><strong>Meal & Wi-Fi Included:</strong> Most PGs provide daily meals (breakfast, lunch, and dinner) and Wi-Fi access to ensure a hassle-free stay.</li>
  <li><strong>Short-Term Stays:</strong> Whether you're visiting for work, exams, or travel, these PGs provide a flexible and cost-effective stay option.</li>
  <li><strong>Secure Environment:</strong> 24/7 security and regular cleaning services for added comfort.</li>
  <li><strong>Affordable Rates:</strong> Pay on a daily basis without the need for a long-term commitment.</li>
</ul>





            <h2>Om Sai PG for "Single Room PG in Pune" Contact Number:- </h2>
            <p>Contact Om Sai PG at +91 9763888448 / +91 9922248255. Our PG is strategically located in the heart of Kharadi, one of Pune's most vibrant and accessible neighborhoods, making it an ideal choice for students and professionals alike.</p>

            
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  borderWidth: "0px",
                }}
                border="1"
              >
                <colgroup>
                  <col style={{ width: "49.9491%" }} />
                  <col style={{ width: "49.9491%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - Daily Basis PG in Baner</p>
<p> - Weekly Basis PG in Baner</p>
<p> - Monthly Basis PG in Baner</p>



                    </td>
                    <td style={{ borderWidth: "0px" }}>
                  
<p> - Daily Basis PG in Pune</p>
<p> - PG on Daily Basis in Pune</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h1>Why Choose a Monthly Basis PG in Kharadi, Pune?</h1>

<ul>
  <li><strong>Affordability:</strong> Monthly basis PGs offer flexible and affordable accommodation options. You can find various PGs within your budget range, and they provide basic amenities such as food, Wi-Fi, and laundry services. This makes it an excellent option for individuals on a budget.</li>
  
  <li><strong>Flexible Duration of Stay:</strong> The monthly basis system allows you to stay for one month or more, providing flexibility. It’s a great option if you're new to Pune and unsure of how long you’ll be staying in Kharadi, as you won’t be tied to a long-term lease.</li>
  
  <li><strong>Convenience:</strong> PGs in Kharadi provide essential services like home-cooked meals, Wi-Fi, cleaning, and laundry on a monthly basis, so you don’t need to worry about these tasks. Everything is taken care of, giving you more time to focus on your studies or work.</li>
  
  <li><strong>Proximity to IT Parks and Colleges:</strong> Kharadi is home to some of the largest IT parks in Pune, such as Eon IT Park and Kharadi Knowledge Park. Additionally, there are many reputed educational institutions in nearby areas, making it a prime location for both working professionals and students.</li>
  
  <li><strong>Safety and Security:</strong> Many PGs in Kharadi are equipped with 24/7 security, CCTV surveillance, and restricted entry systems to ensure the safety and well-being of residents, particularly important for students and working women.</li>
  
  <li><strong>Peaceful Environment:</strong> Kharadi offers a relatively peaceful and residential environment compared to the busy central areas of Pune. This ensures a conducive atmosphere for both work and relaxation.</li>
  
  <li><strong>Well-Connected Location:</strong> Kharadi is strategically located with good access to public transport (buses, cabs, and auto-rickshaws). Additionally, it’s close to Pune Airport and Railway Station, making travel convenient.</li>
</ul>

              <div className="">
                  <h2>
                  FAQs for Monthly Basis PG in Kharadi ? 
                  </h2>
                  {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                      <div
                        className={`faq-question ${
                          activeIndex === index ? "active" : ""
                        }`}
                        onClick={() => toggleAccordion(index)}
                      >
                        {index + 1}. {faq.question}
                      </div>
                      {activeIndex === index && (
                        <div className="faq-answer">{faq.answer}</div>
                      )}
                    </div>
                  ))}
                </div>


                  {/* ======================== */}
                  <div className="container">
                    <div className="testimonial-section">
                  <h2>
                  Testimonial for “Om Sai PG” for Monthly Basis PG in Kharadi: -  {" "}
                  </h2>
                  <Slider {...settings}>
                    {testimonials.map((testimonial, index) => (
                      <div key={index} className="testimonial-slide">
                        <blockquote>
                          <p>{testimonial.quote}</p>
                          <footer>— {testimonial.author}</footer>
                        </blockquote>
                      </div>
                    ))}
                  </Slider>
                  </div>
                </div>

                {/* ================= */}
                <ContactNumber></ContactNumber>
            </div>
           <RecentPost></RecentPost>
        
        </div>
        </div>
      </div>
    </>
  );
}
